import {cloneDeep, get} from 'lodash';
import {
  getOrgHealth,
  // getRoleHierarchy,
  getRoleFlattenedHierarchy,
  getSkillHealth,
  getSelectedRoleDetails,
  getSelectedRoleSuccessProfile,
  getSelectedRoleUsers,
  getUserProcessReport,
  getUserJourneyReport,
  getAnalytics, getAppliedFilter,
} from '../../selectors/viewDemo';
import {
  demoFlowTypes,
  demoFlowView,
  userView,
  skillView,
} from '../../utils/constants';

const INIT = 'viewDemo/INIT';
const SET_MAIN_STATS = 'viewDemo/SET_MAIN_STATS';
const SET_FLOW_CONFIG = 'viewDemo/SET_FLOW_CONFIG';
const SET_USER_VIEW = 'viewDemo/SET_USER_VIEW';
const SET_FLOW_TYPE = 'viewDemo/SET_VIEW';
const SET_EVAL_STEP = 'viewDemo/SET_EVAL_STEP';

const setMainStats = mainStats => ({type: SET_MAIN_STATS, mainStats});
const setFlowConfig = (flowKey, flowVal) => ({
  type: SET_FLOW_CONFIG,
  flowKey,
  flowVal,
});

const init = () => async (dispatch, getState) => {
  const orgHealth = getOrgHealth();
  await dispatch(setMainStats({orgHealth}));
  await dispatch(
    setFlowConfig('orgHierarchyFlattened', getRoleFlattenedHierarchy()),
  );
  await dispatch(setFlowConfig('skillHealthData', getSkillHealth()));

  // const roleHierarchy = getRoleHierarchy();
  // dispatch(setFlowConfig('orgHierarchy', getRoleHierarchy()));
  // await dispatch(renderChart());
  // dispatch(setFlowConfig('orgHierarchyFlattened', getRoleFlattenedHierarchy()));
};

const renderChart = () => (dispatch, getState) => {
  dispatch(setFlowConfig('renderingChart', true));
};

const selectRole = roleId => (dispatch, getState) => {
  dispatch(setFlowConfig('view', demoFlowView.SUCCESS_PROFILE));
  dispatch(setFlowConfig('selectedRoleId', roleId));
  dispatch(
    setFlowConfig('selectedRoleDetails', getSelectedRoleDetails(getState())),
  );
  dispatch(
    setFlowConfig(
      'selectedRoleSuccessProfile',
      getSelectedRoleSuccessProfile(getState()),
    ),
  );
  dispatch(
    setFlowConfig('selectedRoleUsers', getSelectedRoleUsers(getState())),
  );
};

const navigate = way => (dispatch, getState) => {
  if (way === 'back') {
    dispatch(setFlowConfig('view', demoFlowView.HIERARCHY));
    dispatch({
      type: SET_FLOW_TYPE,
      flowType: demoFlowTypes.ROLE_USER_DETAILS,
    });
  } else {
  }
};

const selectUser = user => (dispatch, getState) => {
  dispatch(setFlowConfig('view', demoFlowView.ROLES));
  dispatch(setFlowConfig('selectedUser', user));
  dispatch(
    setFlowConfig(
      'selectedUserProcessReport',
      getUserProcessReport(getState()),
    ),
  );
  dispatch(
    setFlowConfig(
      'selectedUserJourneyReport',
      getUserJourneyReport(getState()),
    ),
  );
  dispatch(
    setFlowConfig('selectedUserJourneyAnalytics', getAnalytics(getState())),
  );
  dispatch({type: SET_USER_VIEW, view: userView.EVALUATION});
};

const setUserView = view => dispatch => {
  if (userView.EVALUATION === view) {
    dispatch({type: SET_EVAL_STEP, step: 'final'});
  } else {
    dispatch({type: SET_EVAL_STEP, step: null});
  }
  dispatch({type: SET_USER_VIEW, view});
};

const setFlowType = flowType => dispatch => {
  dispatch({type: SET_FLOW_TYPE, flowType});
};

const setEvaluationStep = step => (dispatch, getState) => {
  dispatch(setFlowConfig('appliedFilter', {category: null, nature: null}))
  dispatch(
    setFlowConfig(
      'selectedUserProcessReport',
      getUserProcessReport(getState()),
    ),
  );
  dispatch({type: SET_EVAL_STEP, step});
};

const setSkillHealthType = type => dispatch => {
  dispatch(setFlowConfig('selectedSkillHealthView', type));
};

const filterSkillEvaluation = (type, val) => (dispatch, getState) => {

  let filterData = getUserProcessReport(getState());
  const appliedFilter = getAppliedFilter(getState());

  const filterType = appliedFilter[type];

  if (filterType === val) {
    filterData = getUserProcessReport(getState())
    dispatch(setFlowConfig('appliedFilter', {category: null, nature: null}))
  } else {
    if (type === 'nature') {
      filterData = filterData.filter(item => item.nature.toLowerCase() === val.toLowerCase());
    }

    if (type === 'category') {
      filterData = filterData.filter(item => item.category.toLowerCase() === val.toLowerCase());
    }
    dispatch(setFlowConfig('appliedFilter', {[type]: val}))
  }

  dispatch(
    setFlowConfig(
      'selectedUserProcessReport',
      filterData,
    ),
  );

}

export const ACTIONS = {
  init,
  renderChart,
  selectRole,
  navigate,
  selectUser,
  setUserView,
  setFlowType,
  setEvaluationStep,
  setSkillHealthType,
  filterSkillEvaluation,
  // submitPassword,
};

const getFlowConfigList = (flowKey, flowVal, state) => {
  const {flowConfig} = state;

  const newFlowConfig = cloneDeep(flowConfig);

  newFlowConfig[flowKey] = flowVal;
  return {
    flowConfig: newFlowConfig,
  };
};

const defaultState = {
  mainStats: {},
  selectedFlowType: demoFlowTypes.ROLE_USER_DETAILS,
  flowConfig: {
    view: demoFlowView.HIERARCHY,
    renderingChart: false,
    skillHealthData: [],
    // orgHierarchy: {},
    orgHierarchyFlattened: [],
    selectedRoleId: null,
    selectedRoleDetails: null,
    selectedRoleSuccessProfile: {},
    selectedRoleUsers: [],
    selectedUser: null,
    selectedUserProcessReport: [],
    selectedUserJourneyAnalytics: [],
    selectedUserJourneyReport: [],
    selectedSkillHealthView: skillView.FUTURE_READY,
    appliedFilter: {
      category: null,
      nature: null,
    }
  },
  userSelectedView: null,
  currentEvaluationStep: 'final',
};

function viewDemo(state = defaultState, action) {
  switch (action.type) {
    // case INIT:
    //   return Object.assign({}, state);
    case SET_MAIN_STATS:
      return Object.assign({}, state, {
        mainStats: action.mainStats,
      });
    case SET_FLOW_CONFIG:
      return Object.assign(
        {},
        state,
        getFlowConfigList(action.flowKey, action.flowVal, state),
      );
    case SET_USER_VIEW:
      return Object.assign({}, state, {
        userSelectedView: action.view,
      });
    case SET_FLOW_TYPE:
      return Object.assign({}, state, {
        selectedFlowType: action.flowType,
      });
    case SET_EVAL_STEP:
      return Object.assign({}, state, {
        currentEvaluationStep: action.step,
      });
    // case SET_SKILL_VIEW:
    //   return Object.assign({}, state, {
    //     currentEvaluationStep: action.step,
    //   });
    // case SET_ERROR:
    //   return Object.assign({}, state, {
    //     errorMessage: action.err,
    //   });
    // case SET_SUCCESS:
    //   return Object.assign({}, state, {
    //     successMessage: action.successMessage,
    //   });
    // case SET_SUBMITTING:
    //   return Object.assign({}, state, {
    //     submitting: action.bool,
    //   });
    // case SET_VALIDATION_TXT:
    //   return Object.assign({}, state, {
    //     validationTxt: action.txt,
    //   });
    default:
      return Object.assign({}, state);
  }
}

export default viewDemo;



// WEBPACK FOOTER //
// ./src/reducers/routeReducers/viewDemo.js